import { useEffect, useRef } from 'react';

export const useCatalogRefetchBlur = (
  queryKey: string,
  isRefetching: boolean
) => {
  const hasMountedRef = useRef(false);
  const prevQueryKeyRef = useRef(queryKey);
  const shouldBlurRef = useRef(false);

  useEffect(() => {
    if (!hasMountedRef.current) {
      hasMountedRef.current = true;
      prevQueryKeyRef.current = queryKey;
      return;
    }

    if (prevQueryKeyRef.current !== queryKey) {
      shouldBlurRef.current = true;
      prevQueryKeyRef.current = queryKey;
    }
  }, [queryKey]);

  if (!isRefetching && shouldBlurRef.current) {
    shouldBlurRef.current = false;
  }

  return isRefetching && shouldBlurRef.current;
};
